<!--
  CustomerReviewAgentRiskLevelFilter renders a filter with dropdown options for customer review agent risk levels
  and reads/writes from the `customer_risk_levels` URL query param.
-->

<script>
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';
import { CUSTOMER_RISK_LEVEL } from '@/constants/customerReviewAgent';
import { riskLevelToReadableLabel } from '@/constants/riskLevels';

const RISK_LEVEL_TO_LABEL = {};
const risks = [
  CUSTOMER_RISK_LEVEL.LOW,
  CUSTOMER_RISK_LEVEL.MEDIUM,
  CUSTOMER_RISK_LEVEL.HIGH,
  CUSTOMER_RISK_LEVEL.NOT_APPLICABLE,
];
risks.forEach((risk) => {
  RISK_LEVEL_TO_LABEL[risk] = riskLevelToReadableLabel(risk);
});

export default {
  components: {
    iFilter,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      options: Object.values(RISK_LEVEL_TO_LABEL).map((label) => ({ label })),
    };
  },
  computed: {
    value() {
      const customer_risk_levels = this.params.customer_risk_levels;
      if (!customer_risk_levels) {
        return [];
      }
      let paramsAsArray = [];
      if (typeof customer_risk_levels === 'string') {
        paramsAsArray = [customer_risk_levels];
      } else {
        paramsAsArray = customer_risk_levels;
      }
      // map query params like 'LOW' to dropdown values like 'Low'
      return paramsAsArray.map((param) => RISK_LEVEL_TO_LABEL[param]);
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(updated) {
      // Convert readable labels back to API parameter values
      const mapEntries = Object.entries(RISK_LEVEL_TO_LABEL);
      const updatedParamVals = updated.selection.map((item) => {
        const [param] = mapEntries.find(([_, label]) => label === item.label);
        return param;
      });
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          customer_risk_levels:
            updatedParamVals.length > 0 ? updatedParamVals : undefined,
        },
      });
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.CUSTOMERS_SEARCH_CLICKED, {
        itemName: `filter_review_agent_risk_level`,
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Fraud"
    data-testid="review-agent-risk-level-filter"
    data-dd-action-name="customers-view-risk-level-filter"
    :options="options"
    :model-value="value"
    :searchable="false"
    @selection-changed="onSelectionChanged"
  />
</template>
